<template>
  <div justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="secondaryLight">
          <v-icon class="white--text">person</v-icon>
          <span class="headline white--text pa-1">Profile</span>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-container>
            <v-row>
              <v-btn icon>
                <v-icon>edit</v-icon>
              </v-btn>
              <span class="mt-2">Editar profile:</span>
              <v-flex xs12 sm12 md12 class="pa-0"
                ><v-divider></v-divider
              ></v-flex>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="First name"
                  counter="20"
                  required
                  hint="Nome"
                  placeholder="Nome"
                  :rules="nameRule"
                  outlined
                  dense
                  v-model="data.first_name"
                  class="mt-3"
                  @change="checkLength('first_name')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Last name"
                  hint="Sobrenome"
                  counter="20"
                  required
                  outlined
                  placeholder="Sobrenome"
                  :rules="nameRule"
                  @change="checkLength('last_name')"
                  dense
                  v-model="data.last_name"
                  class="mt-3"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="E-mail"
                  required
                  type="email"
                  outlined
                  dense
                  placeholder="E-mail"
                  :rules="emailRule"
                  v-model="data.email"
                  @change="checkEmail"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Username"
                  hint="Usuário"
                  counter="20"
                  required
                  disabled
                  outlined
                  dense
                  placeholder="Usuário"
                  :value="user.username"
                ></v-text-field>
              </v-col>
              <v-btn @click="enable = !enable" icon>
                <v-icon :class="[!enable ? 'primary--text' : 'default']">{{
                  enable ? "lock" : "lock_open"
                }}</v-icon>
              </v-btn>
              <span class="mt-2">Trocar senha:</span>
              <v-btn
                class="ma-1 ml-auto"
                color="white"
                icon
                small
                @click="enable = !enable"
              >
                <v-icon :class="[!enable ? 'primary--text' : 'gray--text']">{{
                  !enable ? "expand_less  " : "expand_more"
                }}</v-icon>
              </v-btn>
              <v-flex xs12 sm12 md12 class="pa-0"
                ><v-divider></v-divider
              ></v-flex>

              <v-expand-transition>
                <div v-show="!enable" class="mr-3 ml-3">
                  <v-form ref="form" class="row">
                    <v-col cols="12" sm="6" md="6">
                      <PasswordCheck
                        v-model="data.newPassword"
                        label="Password"
                        :reset="reset"
                        :disabled="enable"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        label="Confirm Password"
                        required
                        placeholder="******"
                        :rules="equalToPassword"
                        type="password"
                        outlined
                        dense
                        v-model="data.confirmPassword"
                        error-count="3"
                      ></v-text-field>
                    </v-col>
                  </v-form>
                  <v-flex xs12 sm12 md12 class="pa-0"
                    ><v-divider></v-divider
                  ></v-flex>
                </div>
              </v-expand-transition>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn @click="close()" depressed width="100">
            <v-icon>close</v-icon>
          </v-btn>
          <v-btn
            color="secondaryLight"
            class="light--text"
            @click="verify()"
            depressed
            width="100"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Confirm
      :showDialog="confirmDialog"
      title="Você tem certeza disso?"
      mainText="Isso atualizará os registros desse usuário."
      auxText="Essa ação não pode ser desfeita."
      @closedDialog="closeConfirm($event)"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PasswordCheck from "@/view/User/Table/PasswordCheck.vue";
import {
  changePassword,
  updateUser,
  getUser,
  getUsers,
  default as User,
} from "@/models/User.js";
import Confirm from "@/view/User/Table/Confirm.vue";
export default {
  props: {
    open: false,
  },
  components: {
    PasswordCheck,
    Confirm,
  },

  data() {
    return {
      dialog: false,
      confirmDialog: false,
      user: [],
      reset: false,
      enable: true,
      data: {
        newPassword: undefined,
        confirmPassword: undefined,
      },
      equalToPassword: [
        (v) => !!v || "Esse campo é obrigatório.",
        (v) =>
          (v && v.length >= 8) || "Senha deve conter pelo menos 8 carateres.",
        (v) => v === this.data.newPassword || "Senhas não coincidem.",
      ],
      emailRule: [
        (v) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || "E-mail inválido";
        },
      ],
      nameRule: [(v) => !!v || "Esse campo é obrigatório."],
      msgs: [
        "Campos inválidos.",
        "Esse sobrenome é inválido.",
        "Esse email é inválido.",
        "Esse email já está sendo usado.",
        "Esse nome  é inválido.",
      ],
      errors: [false, false, false, false, false, false, false],
    };
  },
  watch: {
    open: {
      handler() {
        this.start();
      },
    },
  },
  computed: {
    ...mapGetters(["getCurrentUser"]),
  },
  methods: {
    async verify() {
      let res = await this.checkEmail();
      if (!res || !this.generalCheck()) {
        this.$set(this.errors, 0, true);
      } else {
        this.$set(this.errors, 0, false);

        this.confirmDialog = true;
      }
    },
    async update() {
      let resPassword, resUser;
      if (this.generalCheck()) {
        if (!this.enable) {
          resPassword = await changePassword(
            this.data.id,
            this.data.newPassword
          );
        }
        resUser = await updateUser(this.data);

        if (resPassword || resUser) {
          this.close();
          this.$set(this.errors, 0, false);
        } else {
          this.$set(this.errors, 0, true);
        }
      } else {
        this.$set(this.errors, 0, true);
      }
    },
    async start() {
      this.user = this.getCurrentUser;
      let res = await getUser(this.user);
      if (res) {
        this.data = new User(res);
      }
      this.dialog = this.open;
    },
    async checkEmail() {
      if (this.data.email) {
        let res = this.data.email.includes("@");
        if (res) {
          this.$set(this.errors, 2, false);
          return this.checkEmailExist();
        }
        this.$set(this.errors, 3, false);
        this.$set(this.errors, 2, true);

        return false;
      }
      this.$set(this.errors, 2, false);
      return false;
    },
    async checkEmailExist() {
      if (this.data.email) {
        let res = await getUsers({ email: this.data.email });
        if (res && res.length && res[0].email != this.user.email) {
          this.$set(this.errors, 3, true);
          return false;
        } else {
          this.$set(this.errors, 3, false);
          return true;
        }
      } else {
        this.$set(this.errors, 3, false);

        return false;
      }
    },
    resetFields() {
      this.data.id = undefined;
      this.data.newPassword = undefined;
      this.data.confirmPassword = undefined;
      for (let i = 0; i < this.errors.length; i++) {
        this.$set(this.errors, i, false);
      }
      this.reset = !this.reset;
      this.$refs.form.reset();
    },
    close() {
      this.resetFields();
      this.confirmDialog = false;
      this.dialog = false;
      this.enable = true;
      this.$emit("close", this.dialog);
    },
    check(val) {
      if (val === 0) return false;
      if (!val) {
        return true;
      }
      if (String(val).trim() == "") return true;
      return false;
    },
    generalCheck() {
      if (this.check(this.data.id)) return false;
      if (this.check(this.data.first_name)) return false;
      if (this.check(this.data.last_name)) return false;
      if (this.check(this.data.email)) return false;
      if (!this.enable) {
        if (this.check(this.data.newPassword)) return false;
        if (this.data.newPassword !== this.data.confirmPassword) return false;
        if (!this.checkLength("password")) return false;
      }
      return true;
    },
    closeConfirm(value) {
      this.confirmDialog = false;
      if (value) {
        this.update();
      }
    },

    checkLength(param) {
      let res, erro;
      switch (param) {
        case "first_name":
          res = this.data.first_name.length;
          erro = 4;
          break;
        case "last_name":
          res = this.data.last_name.length;
          erro = 1;
          break;
        case "password":
          if (this.data.newPassword.length >= 8) return true;
          return false;
        default:
          break;
      }

      if (res) {
        this.$set(this.errors, erro, false);
        return true;
      } else {
        this.$set(this.errors, erro, true);
        return false;
      }
    },
  },
  beforeDestroy() {
    this.close();
  },
};
</script>

<style>
</style>